import React, { useEffect, useState } from "react";
import Sidebar from "../../partials/aside/Sidebar";
import httpService from "../../../services/httpServices/httpServices";
import helperNumber from "../../../helpers/numbers";
import userPresenter from "../../../presenter/user/AllUser";
import { Link } from "react-router-dom";
import helperSpinner from "../../../helpers/spinner";
import Pagination from "../../partials/content/Pagination";
import MobileHelper from "../../../helpers/mobile";

function AllUser() {
  const [users, setUsers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [countPage, setCountPage] = useState(1);
  const [countItemPerPage, setCountItemPerPage] = useState(10);
  const [userIDSearchFilter, setUserIDSearchFilter] = useState();
  const [firstNameSearchFilter, setFirstNameSearchFilter] = useState();
  const [lastNameSearchFilter, setLastNameSearchFilter] = useState();

  useEffect(() => {
    getUsers();
  }, [
    currentPage,
    userIDSearchFilter,
    firstNameSearchFilter,
    lastNameSearchFilter,
  ]);

  const getUsers = async () => {
    const searchFilterQuery = getSearchFilterQuery();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const users = await sendRequestGetUser(searchFilterQuery);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!users) {
      return;
    }

    setUsers(users.users);
    setCountPage(users.count_page);
  };

  const sendRequestGetUser = async (searchFilterQuery) => {
    const headersRequest = getHeaderForRequest();
    let users;
    try {
      users = await httpService.getRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/user/paginate?page=${currentPage}&number=${countItemPerPage}${searchFilterQuery}`,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return users.data.data;
  };

  const paginationItemOnClickHandler = async (e) => {
    if (!e.target.attributes[1]) {
      return;
    }

    setCurrentPage(e.target.attributes[1].value);
  };

  const generatePagination = () => {
    return (
      <div className="py-2 d-flex flex-column flex-md-row  align-items-md-center  ">
        <Pagination
          countPage={countPage}
          currentPage={currentPage}
          paginationItemOnClickHandler={paginationItemOnClickHandler}
        />
      </div>
    );
  };

  const getSearchFilterQuery = () => {
    let searchFilterQuery = "";

    if (userIDSearchFilter) {
      searchFilterQuery = `${searchFilterQuery}&id=${userIDSearchFilter}`;
    }

    if (firstNameSearchFilter) {
      searchFilterQuery = `${searchFilterQuery}&first_name=${firstNameSearchFilter}`;
    }

    if (lastNameSearchFilter) {
      searchFilterQuery = `${searchFilterQuery}&last_name=${lastNameSearchFilter}`;
    }

    return searchFilterQuery;
  };

  const enterUserProfile = async (userID) => {
    let token = await sendRequestGetTokenUser(userID);
    if (!token) {
      return;
    }

    localStorage.removeItem("token");
    localStorage.setItem("token", token);
    const url = process.env.REACT_APP_DOMAIN;
    window.location.replace(url);
  };

  const sendRequestGetTokenUser = async (userID) => {
    let token;
    let headersRequest = getHeaderForRequest();
    try {
      token = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/user/enter-users-profile/" +
          userID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return token.data.data;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const sendRequestDeleteUser = async (userID) => {
    let headersRequest = getHeaderForRequest();
    try {
      await httpService.deleteRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/user/" + userID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return true;
  };

  const deleteUser = async (userID) => {
    let isSure = window.confirm("آیا شما مطمئن هستید؟");
    if (!isSure) {
      return;
    }

    const resultSendRequestDeleteUser = await sendRequestDeleteUser(userID);
    if (resultSendRequestDeleteUser) {
      getUsers();
    }
  };

  const generateHtmlTagUsers = () => {
    return (
      <>
        <div class="container-fluid py-2 border border-1 rounded">
          <div class="row py-2">
            <div class="col-12 col-md-4">
              <div>
                <label>جستجو در شماره کاربر</label>
              </div>
              <div>
                <input
                  className="form-control"
                  type="number"
                  defaultValue={userIDSearchFilter}
                  onKeyUp={(e) => setUserIDSearchFilter(e.target.value)}
                  onWheel={(event) => event.currentTarget.blur()}
                />
              </div>
            </div>
          </div>
          <hr />
          <div class="row py-2">
            <div class="col-12 col-md-4">
              <div>
                <label>جستجو در نام</label>
              </div>
              <div>
                <input
                  className="form-control"
                  type="text"
                  onKeyUp={(e) => setFirstNameSearchFilter(e.target.value)}
                />
              </div>
            </div>
            <div class="col-12 col-md-4">
              <div>
                <label>جستجو در نام و خانوادگی</label>
              </div>
              <div>
                <input
                  className="form-control"
                  type="text"
                  onKeyUp={(e) => setLastNameSearchFilter(e.target.value)}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="table-responsive">
          <table className="table table-hilite tbl-td-white-space">
            <thead>
              <tr>
                <td>#</td>
                <td>شماره کاربری</td>
                <td>شماره موبایل</td>
                <td>نقش</td>
                <td>نام</td>
                <td>نام خانوداگی</td>
                <td>مبلغ شارژ کاربر</td>
                <td>تاریخ آخرین ورود</td>
                <td>تاریخ عضویت</td>
                <td>عملیات</td>
              </tr>
            </thead>
            <tbody>
              {users.map((user, index) => {
                return (
                  <tr key={index}>
                    <td>{helperNumber.toPersianNum(index + 1)}</td>
                    <td>{helperNumber.toPersianNum(user.usr_id)}</td>
                    <td dir="ltr">
                      {user.usr_mobile &&
                        helperNumber.toPersianNum(
                          MobileHelper.formatMobile(user.usr_mobile)
                        )}
                    </td>
                    <td>{user.persian_role_name}</td>
                    <td>{user.firstname}</td>
                    <td>{user.lastname}</td>
                    <td className="letter-spacing-finance-number">
                      {helperNumber.toPersianNum(
                        helperNumber.toFormatFinanceNumber(user.usr_charge)
                      )}
                    </td>

                    <td>{user.usr_last_login_at}</td>
                    <td>{user.usr_created_at}</td>
                    <td>
                      <div className="text-nowrap">
                        <span className="pl-2">
                          <Link
                            href="# "
                            className="btn btn-info  "
                            to={`/user/show-info-user/${user.usr_id} `}
                          >
                            <i className="fa fa-info"></i>
                          </Link>
                        </span>
                        <span className="pl-2">
                          <Link
                            href="# "
                            className="btn btn-warning"
                            to={`/report/manage/campaign/${user.usr_id} `}
                          >
                            <i className="fa fa-chart-line"></i>
                          </Link>
                        </span>

                        <span className="pl-2">
                          <span
                            className="btn btn-success  "
                            onClick={() => enterUserProfile(user.usr_id)}
                          >
                            <i className="fa fa-sign-in-alt"></i>
                          </span>
                        </span>

                        <span>
                          <span
                            className="btn btn-danger  btn-danger"
                            // onClick={() => deleteUser(user.usr_id)}
                          >
                            <i className="fa fa-trash"></i>
                          </span>
                        </span>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        {countPage > 1 ? generatePagination() : <></>}
      </>
    );
  };

  return (
    <>
      <Sidebar openItem="users" activeItem="user-all" />

      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">همه کاربران</h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              <div>
                <Link
                  to="/user/all-user-deleted"
                  className="mb-1 btn btn-danger"
                >
                  <span className="pl-2">
                    <i className="fa fa-trash"></i>
                  </span>
                  <span>کاربران حذف شده</span>
                </Link>
              </div>
              <div>
                {users.length == 0 &&
                userIDSearchFilter == null &&
                firstNameSearchFilter == null &&
                lastNameSearchFilter == null ? (
                  <></>
                ) : (
                  generateHtmlTagUsers()
                )}
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

// export default connect(mapStateToProps, mapDispatchToProps)(AllUser);
export default AllUser;
